import MainLayout from 'layout/MainLayout';
import PostListPage from 'views/blog-post-list-page';
import PostDetailPage from 'views/blog-post-detail-page';

const BlogRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/blog',
            element: <PostListPage />
        },
        {
            path: '/blog/detail/:id',
            element: <PostDetailPage />
        },
        {
            path: '/blog/detail/:id/:title',
            element: <PostDetailPage />
        },
        {
            path: '/blog/:slug/:page',
            element: <PostListPage />
        },
        {
            path: '/blog/:slug',
            element: <PostListPage />
        }
    ]
};

export default BlogRoutes;
